<!-- 加入外协链弹框 -->
<template>
  <el-dialog
    title="选择一个目录"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="directory-tree-container">
      <el-tree
        ref="tree"
        :data="treeData"
        :props="defaultProps"
        node-key="nodeKey"
        :highlight-current="true"
        :default-expanded-keys="defaultExpandedKeys"
        @node-click="handleNodeClick"
        @node-expand="handleNodeExpand"
      >
        <span
          class="custom-tree-node"
          slot-scope="{ node, data }"
        >
          <span class="node-content">
            <span class="node-label">{{ node.label }}</span>
            <span
              v-if="data.count !== undefined"
              class="node-count"
            >({{ data.count }})</span>
          </span>
        </span>
      </el-tree>
    </div>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button size="small" @click="handleCancel">取消</el-button>
      <el-button
        type="primary"
        size="small"
        @click="handleConfirm"
        :disabled="!selectedNode"
      >确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Category } from "@/libs";
import { ProductService } from '@/service/outsource'
import { CompService } from '@/service'
import { Message } from 'element-ui'
import {AuthService} from '@/service'

export default {
  name: 'DirectorySelector',
  props: {
    equimpId: {
      type: [Number, String]
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      user: AuthService.user(),
      // 当前选中的目录节点
      selectedNode: null,
      // 树形目录的数据源
      treeData: [],
      // el-tree 组件的属性配置
      defaultProps: {
        hasChildren: 'hasChildren', // 是否有子节点的标识字段
        children: 'childNodes', // 子节点字段名
        label: 'DirName'        // 显示文本字段名
      },
      // 默认展开的节点 key 数组
      defaultExpandedKeys: []
    }
  },
  mounted () {
    this.initTree()
  },
  methods: {
    // 初始化树形数据
    initTree () {
      this.selectedNode = null
      let companyData = []
      // 判断是否是管理员
      // "GreatCraftsman" = 这个是个人版
      if(this.user.IsManager == 1 && window.md.getAppName() == 'GreatCraftsmanEnt') {
        companyData = [{
          childNodes: [{}],
          DirID: 0,
          DirName: '企业外协装备',
          CategoryType: 'OutSourceDirCompany',
          CategoryID: Category.OutSourceDirCompany,
          nodeKey: 1,
        }]
      }
      this.treeData.push(...companyData, ...[{
        childNodes: [{}],
        DirID: 0,
        DirName: '我的外协装备',
        CategoryType: 'OutSourceDirEquimps',
        CategoryID: Category.OutSourceDirEquimp,
        nodeKey: 2
      }])
    },

    // 获取节点图标
    getNodeIcon (node, data) {
      if (node.expanded) {
        return 'el-icon-arrow-down'
      } else if (node.childNodes && node.childNodes.length > 0) {
        return 'el-icon-arrow-right'
      }
      return 'el-icon-folder'
    },

    // 节点点击事件
    handleNodeClick (data, node) {
      this.selectedNode = data
      this.$refs.tree.setCurrentKey(data.value)
    },

    // 节点展开事件
    async handleNodeExpand (data, node) {
      if (data.childNodes && data.childNodes.length > 0 && data.childNodes[0].DirID !== undefined) {
        return
      }
      const res = await ProductService.getTreeList(data.CategoryID, data.DirID)
      data.childNodes = res.map(item => {
        let childNodes = []
        if(!item.IsLeaf){
          // 判断是否有子节点
          childNodes.push({})
        }
        return {
          ...item,
          childNodes: childNodes // 初始化子节点数组
        }
      })
    },

    async handleConfirm () {
      if (this.selectedNode) {
        await CompService.enterpriseInsertOut(this.selectedNode.DirID, this.selectedNode.CategoryID, this.equimpId)
        Message.success('添加成功');
        // 通知 tree-list 更新数量
        this.$root.$emit('updateTreeCount', {
          dirId: this.selectedNode.DirID,
          categoryId: this.selectedNode.CategoryID,
          increment: 1
        });
        this.$emit('confirm', this.selectedNode)
        this.handleClose()
      }
    },

    handleCancel () {
      this.$emit('cancel')
      this.handleClose()
    },

    handleClose () {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>

/deep/ .el-dialog__body {
  padding: 10px 20px;
  max-height: 600px;
  overflow: auto;
}
.directory-tree-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 0px 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.node-content {
  display: flex;
  align-items: center;
  width: 100%;
}

.node-icon {
  margin-right: 8px;
  font-size: 14px;
  color: #909399;
}

.node-label {
  flex: 1;
  color: #303133;
}

.node-count {
  color: #909399;
  font-size: 12px;
  margin-left: 4px;
}

.dialog-footer {
  text-align: right;
}

/deep/ .el-tree-node {
  padding-left: 10px;
}
// 自定义树节点样式
/deep/ .el-tree-node__content {
  height: 32px;
}

/deep/ .el-tree-node__content:hover {
  background-color: #f5f7fa;
}

/deep/ .el-tree-node.is-current > .el-tree-node__content {
  background-color: #e6f7ff;
  color: #1890ff;
}

/deep/ .el-tree-node__expand-icon {
  font-size: 17px;
  color: #909399;
  position: absolute;
  margin-left: -30px;
}

/deep/ .el-tree-node__expand-icon.expanded {
  transform: rotate(90deg);
}

/deep/ .el-tree-node__expand-icon.is-leaf {
  display: none;
}
</style>